export default {
  data: () => ({
    translations: {
      title: {
        el: 'Όνομα',
        en: 'Title',
        it: 'Nome',
      },
      description: {
        el: 'Περιγραφή',
        en: 'Description',
        it: 'Descrizione',
      },
      from_points: {
        el: 'Από',
        en: 'From Points',
        it: 'Da Punti',
      },
      from_cashback: {
        el: 'Από',
        en: 'From Cashback',
        it: 'Da Cashback',
      },
      multiplier: {
        el: 'Πολλαπλασιαστής',
        en: 'Multiplier',
        it: 'Moltiplicatore',
      },
      to_points: {
        el: 'Εώς',
        en: 'To Points',
        it: 'A Punti',
      },
      to_cashback: {
        el: 'Εώς',
        en: 'To Cashback',
        it: 'A Cashback',
      },
      addPointPackage: {
        el: 'Προσθήκη Πακέτου',
        en: 'Add New Package',
        it: 'Aggiungere un Pacchetto',
      },
      updatePointPackage: {
        el: 'Επεξεργασία Πακέτου',
        en: 'Update Package',
        it: 'Aggiornare Pacchetto',
      },
      color: {
        el: 'Επιλογή ΧρώΜατος',
        en: 'Color',
        it: 'Selezione del colore',
      },
      from: {
        el: 'Από',
        en: 'From',
        it: 'Da',
      },
      to: {
        el: 'Εώς',
        en: 'To',
        it: 'A',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancellare',
      },
      editPointTier: {
        el: 'Επεξεργασία Επιπέδων',
        en: 'Edit Tier',
        it: 'Nuovo Livello',
      },
      edit: {
        el: 'Επεξεργασία',
        en: 'Edit',
        it: 'Modifica',
      },
      addNewPointTier: {
        el: 'Προσθήκη Νέας Επιπέδων',
        en: 'Add New Tier',
        it: 'Aggiungere un Nuovo Livello',
      },
      createPointTiers: {
        el: 'Δημιουργία Επιπέδων',
        en: 'Create Tiers',
        it: 'Creare Livelli',
      },
      saveChanges: {
        el: 'Αποθήκευση Αλλαγών',
        en: 'Save Changes',
        it: 'Salva le Modifiche',
      },
      confirmSaveMsg: {
        el: `Λόγω αλλαγών στα όρια των επιπέδων, με αυτή την ενέργεια θα γίνει ανακατάταξη των χρηστών σε νέα επίπεδα. 
                `,
        en: `Due to changes in tier limits, this action will reclassify users to new tiers. 
                `,
        it: `A causa delle modifiche ai limiti di livello, questa azione riclassificherà gli utenti in nuovi livelli. 
                `,
      },
      saveAlert: {
        el: 'Προειδοποίηση Αποθήκευσης Αλλαγών',
        en: 'Save Changes Alert',
        it: 'Avviso di Salvataggio delle Modifiche',
      },
      resetChanges: {
        el: 'Επαναφορά Αλλαγών',
        en: 'Reset Changes',
        it: 'Modifiche di Reset',
      },
      deleteTiers: {
        el: 'Διαγραφή όλων',
        en: 'Delete All Tiers',
        it: 'Eliminare tutti i livelli',
      },
      confirmDeleteTiers: {
        el: 'Αυτή η ενέργεια θα διαγράψει όλα τα επίπεδα .',
        en: 'This action will delete all tiers.',
        it: 'Questa azione cancella tutti i livelli.',
      },
      update: {
        el: 'Ενημέρωση',
        en: 'Update',
        it: 'Aggiornamento',
      },
      enableTierCreationAlert: {
        el: 'Παρακαλώ ενεργοποιήστε τη δημιουργία επιπέδων από τις ρυθμίσεις στο Προφίλ Επιχείρησης.',
        en: 'Please enable tiers creation from settings in Business Profile.',
        it: 'Attivare la creazione di livelli dalle impostazioni del Profilo aziendale.',
      },
      expirationDays: {
        el: 'Ημέρες λήξεως',
        en: 'Expiration days',
        it: 'Giorni di Scadenza',
      },
      expirationDaysDescription: {
        el: 'Ορίστε περισσότερες από 0 ημέρες. Από την ημέρα αντιστοίχισης σε αυτό το επίπεδο μέχρι και το πέρας των ημερών λήξης του, ο χρήστης θα διατηρήσει τα προνόμια του επιπέδου αυτού, ακόμα και αν βρεθεί κάτω από το αρχικό όριο που έχει οριστεί.',
        en: 'Set more than 0 days. From the day of assignment to this level until the end of its expiration days, user will keep the privileges of this tier, even after getting below the tier starting point.',
        it: "Impostare più di 0 giorni. Dal giorno dell'assegnazione a questo livello fino alla fine dei suoi giorni di scadenza, l'utente manterrà i privilegi di questo livello, anche dopo essere sceso al di sotto del punto di partenza impostato.",
      },
      countableDays: {
        el: 'Ημέρες υπολογίσιμων συναλλαγών',
        en: 'Countable transactions days',
        it: 'Giorni di transazioni conteggiabili',
      },
      countableDaysDescription: {
        el: '',
        en: '',
        it: '',
      },
      tiersNumber: {
        el: 'Αριθμός Επιπέδων',
        en: 'Number of Tiers',
        it: 'Numero di livelli',
      },
      starting_points: {
        el: 'Ελάχιστοι Πόντοι',
        en: 'Starting Points',
        it: 'Punti di Partenza',
      },
      starting_cashback: {
        el: 'Ελάχιστο Cashback',
        en: 'Starting Cashback',
        it: 'Cashback di Partenza',
      },

      startingAmount: {
        el: 'Ελάχιστο Ποσό',
        en: 'Starting Amount',
        it: 'Importo di Partenza',
      },
    },
  }),
};
